import React from 'react'

export default function NewContent() {
  return (
					<section className="section">
							<div className="row">
								<div className="col-12">
									<div className="card">
										<div className="card-header">
											<h4>คาร์บอนฟุตพริ้นท์ในระดับองค์กร (Carbon Footprint for Organization: CFO)</h4>
											<span>คือ การประเมินปริมาณการปล่อยและดูดกลับก๊าซเรือนกระจกที่เกิดจากกิจกรรมต่าง ๆ ที่เกี่ยวข้องกับองค์กรในแต่ละปีทั้งทางตรงและทางอ้อม

											</span>
										</div>
										<div className="card-body">
											<ul className="nav nav-pills pb-3" id="myTab3" role="tablist">
												<li className="nav-item">
													<a className="nav-link active" id="home-tab3" data-toggle="tab" href="#tab1" role="tab" aria-controls="home" aria-selected="true">สำหรับข้อมูลทั่วไป</a>
												</li>
												<li className="nav-item">
													<a className="nav-link" id="profile-tab3" data-toggle="tab" href="#tab2" role="tab" aria-controls="profile" aria-selected="false">สำหรับคำอธิบายกรอกข้อมูล</a>
												</li>
											</ul>
											<div className="tab-content border-top p-3" id="myTabContent3">
												<div className="tab-pane fade show active p-0" id="tab1" role="tabpanel" aria-labelledby="home-tab3">
													<div className="row">
														<div className="col-lg-6 col-md-12 col-12 col-sm-12">
															<div className="card">
																<div className="img-container">
																	<img src="img/carbon.jpg" alt=""/>
																	<div className="overlay text-center">
																		<h4 className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h4>
																		<button type="button" className="btn btn-primary">Read More</button>
																	</div>
																</div>
															</div>
														</div>
														<div className="col-lg-6 col-md-12 col-12 col-sm-12">
															<div className="card">
																<div className="img-container">
																	<img src="img/carbon.jpg" alt=""/>
																	<div className="overlay text-center">
																		<h4 className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h4>
																		<button type="button" className="btn btn-primary">Read More</button>
																	</div>
																</div>
															</div>
														</div>
														<div className="col-lg-6 col-md-12 col-12 col-sm-12">
															<div className="card">
																<div className="img-container">
																	<img src="img/carbon.jpg" alt=""/>
																	<div className="overlay text-center">
																		<h4 className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h4>
																		<button type="button" className="btn btn-primary">Read More</button>
																	</div>
																</div>
															</div>
														</div>
														<div className="col-lg-6 col-md-12 col-12 col-sm-12">
															<div className="card">
																<div className="img-container">
																	<img src="img/carbon.jpg" alt=""/>
																	<div className="overlay text-center">
																		<h4 className="text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h4>
																		<button type="button" className="btn btn-primary">Read More</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="tab-pane fade p-0" id="tab2" role="tabpanel" aria-labelledby="profile-tab3">
													tab2.
												</div>
												
											</div>
										</div>
									</div>
								</div>
							</div>
					</section>
		
  )
}
